// frontend/src/admin/components/PaymentChart.js
// Graphique d'évolution des revenus avec Recharts
import React from 'react';
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const PaymentChart = ({ data, type = 'area' }) => {
  // Données de démonstration si pas de data fournie
  const defaultData = [
    { date: '01/12', revenue: 120, subscriptions: 5 },
    { date: '02/12', revenue: 180, subscriptions: 7 },
    { date: '03/12', revenue: 150, subscriptions: 6 },
    { date: '04/12', revenue: 220, subscriptions: 9 },
    { date: '05/12', revenue: 280, subscriptions: 12 },
    { date: '06/12', revenue: 310, subscriptions: 14 },
    { date: '07/12', revenue: 290, subscriptions: 13 },
  ];

  const chartData = data || defaultData;

  // Tooltip personnalisé
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '12px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '1px solid #e5e7eb'
          }}
        >
          <p style={{ margin: 0, fontWeight: 600, marginBottom: '8px' }}>
            {label}
          </p>
          {payload.map((entry, index) => (
            <p
              key={index}
              style={{
                margin: 0,
                color: entry.color,
                fontSize: '14px'
              }}
            >
              {entry.name}: {entry.value}€
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  // Rendu selon le type de graphique
  if (type === 'line') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="date"
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis stroke="#6b7280" style={{ fontSize: '12px' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ fontSize: '14px', paddingTop: '10px' }}
          />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#3b82f6"
            strokeWidth={3}
            name="Revenus"
            dot={{ fill: '#3b82f6', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="subscriptions"
            stroke="#10b981"
            strokeWidth={3}
            name="Abonnements"
            dot={{ fill: '#10b981', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  }

  if (type === 'bar') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="date"
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis stroke="#6b7280" style={{ fontSize: '12px' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ fontSize: '14px', paddingTop: '10px' }}
          />
          <Bar dataKey="revenue" fill="#3b82f6" name="Revenus" radius={[8, 8, 0, 0]} />
          <Bar dataKey="subscriptions" fill="#10b981" name="Abonnements" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    );
  }

  // Par défaut : Area chart (le plus joli)
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={chartData}>
        <defs>
          <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.1} />
          </linearGradient>
          <linearGradient id="colorSubscriptions" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#10b981" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis
          dataKey="date"
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <YAxis stroke="#6b7280" style={{ fontSize: '12px' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: '14px', paddingTop: '10px' }}
        />
        <Area
          type="monotone"
          dataKey="revenue"
          stroke="#3b82f6"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorRevenue)"
          name="Revenus"
        />
        <Area
          type="monotone"
          dataKey="subscriptions"
          stroke="#10b981"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorSubscriptions)"
          name="Abonnements"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default PaymentChart;